/* eslint-disable max-len */

function removeSpaces(str) {
  if (!str) return '';

  return typeof str === 'string' ? str.replace(/ /g, '') : str;
}

export const required = (v) => {
  if (Array.isArray(v) && v.length === 0) return 'Выберите хотя бы один элемент';
  return !!removeSpaces(v) || 'Поле обязательно';
};

export const email = (v) => /.+@.+\..+/.test(removeSpaces(v)) || 'Email должен быть валидным';

export const min = (n) => (v) => removeSpaces(v).length >= n || `Минимум ${n} символов`;

export const max = (n) => (v) => removeSpaces(v).length <= n || `Максимум ${n} символов`;

export const minVal = (n) => (v) => (Number(v) < n ? `Значение поля минимум ${n}` : null);

export const maxVal = (n) => (v) => (Number(v) > n ? `Значение поля максимум ${n}` : null);

export const same = (value, message) => (v) => removeSpaces(v) === removeSpaces(value) || message || 'Поля не совпадают';

export const phone = (v) => /^(\+7|7|8)?[\s-]?\(?[489][0-9]{2}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/.test(removeSpaces(v)) || 'Введите валидный номер';

export const link = (v) => /((https?:\/\/)?[^\s.]+\.[\w][^\s]+)/.test(removeSpaces(v)) || 'Введите корректную ссылку';

export default {
  required,
  email,
  min,
  max,
  same,
  phone,
  link,
  minVal,
  maxVal,
};
